import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function FamilyLawPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas['family-law']} />;
}
